module.exports = __webpack_public_path__ + "media/src/images/zu_exp_03-2561504a8361af7fb7a41d1cdf548608.gif";